import { stringify } from 'query-string';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import { EntityTypes, SalesTypes } from 'context/entityContext';

import { TopicFilterNames } from 'components/TopicFilters/shared';
import getRegionBreakdown from 'helpers/getRegionBreakdown';
import getCountryIds from 'helpers/getCountryIds';
import { MAX_LIMIT } from 'config';

interface IBreakdownURLArgs {
  countryIds?: string[];
  customerFilter?: TopicFilterNames;
  download?: boolean;
  entityIds: string[];
  entityType: EntityTypes;
  salesType: SalesTypes;
  userData?: boolean;
  mediaTypes?: string;
  access?: boolean;
  region?: string;
  limit?: number;
  compareMode?: string;
  customRegion?: string | string[];
}

export default function getBreakdownURL(options: IBreakdownURLArgs): string {
  const {
    countryIds,
    customerFilter = 'all',
    download,
    entityIds,
    entityType,
    salesType,
    userData,
    mediaTypes,
    access,
    region,
    limit = MAX_LIMIT,
    compareMode,
    customRegion,
  } = options;

  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    customerFilter,
    download,
    userData,
    mediaTypes,
    limit: access ? limit : undefined,
    regionBreakdown: getRegionBreakdown(
      countryIds,
      region,
      compareMode,
      customRegion
    ),
  });

  const type = entityTypeToApiType(entityType);

  return `/api/${salesType}${
    access ? '/access' : ''
  }/breakdown/${type}/${entityIds}?${params}`;
}
